__turbopack_context__.v({
  "border": "xlWm3a_border",
  "container": "xlWm3a_container",
});
